import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasLayoutComponent } from './gas-layout.component';
import { GasHeaderModule } from '../gas-header/gas-header.module';
import { GasMenuModule } from '../gas-menu/gas-menu.module';

const COMPONENTS = [
  GasLayoutComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasHeaderModule,
    GasMenuModule,
  ],
})
export class GasLayoutModule { }
